export default __webpack_public_path__ + "static/media/photo.1a7a52ab.png";